import { Text } from '@chakra-ui/react';
import moment from 'moment';

import { getFormatDateFromStoreDate } from 'shared-components';
import { TravelStatusEnum } from 'types';

import { ITravelStatus } from '../../../../../../../types';

interface IProps {
  travelStatus: ITravelStatus;
}
export const IntroWrapper = ({ travelStatus: { status, bookedDate, arrivalDate } }: IProps) => {
  status = status || TravelStatusEnum.None;
  switch (status) {
    case TravelStatusEnum.None: {
      return (
        <>
          <Text>
            You have not entered a travel status. Once you enter your status you will be able to return and update it if
            it changes.
          </Text>
        </>
      );
    }
    case TravelStatusEnum.Booked: {
      return (
        <Base
          status={
            <>
              <b>
                booked to arrive on {moment(getFormatDateFromStoreDate(bookedDate), 'DD/MM/YYYY').format('DD MMM YYYY')}
              </b>
            </>
          }
        />
      );
    }
    case TravelStatusEnum.TravelCancelled: {
      return <Base status={<b>travel canceled</b>} />;
    }
    case TravelStatusEnum.TravelPrevented: {
      return <Base status={<b>travel prevented</b>} />;
    }
    case TravelStatusEnum.Defer: {
      return <Base status={<b>Intends to Defer</b>} />;
    }
    case TravelStatusEnum.Withdraw: {
      return <Base status={<b>Intends to Withdraw</b>} />;
    }

    case TravelStatusEnum.Arrived: {
      return (
        <Base
          status={<b>Arrived {moment(getFormatDateFromStoreDate(arrivalDate), 'DD/MM/YYYY').format('DD MMM YYYY')}</b>}
        />
      );
    }

    case TravelStatusEnum.AlreadyInUk: {
      return <Base status={<b>Already in UK</b>} />;
    }

    default: {
      return <></>;
    }
  }
};

const Base = ({ status }: { status: JSX.Element }) => {
  return (
    <>
      <Text>You have told us you are {status}. If it is correct you do not have to do anything on this page.</Text>

      <Text>If your travel plan has changed, please let us know by completing this page.</Text>
    </>
  );
};
